(function ($) {
	'use strict';

	$(function () {
		$('.js-big-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navParent = $('.js-big-carousel-nav', sliderContainer);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				slidesPerView: 1,
				centeredSlides: true,
				navigation: false,
				spaceBetween: 20,
				on: {
					beforeInit: function () {
						let numSlides = this.wrapperEl.querySelectorAll('.js-carousel-slide').length;

						if (numSlides <= 1) {
							this.params.loop = false;
							navParent.css('display', 'none');
						}
					},
				}
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
					counterEl.html(swiper.realIndex + 1);
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
					counterEl.html(swiper.realIndex + 1);
				});
			});
		});
	});
})(jQuery, document, window);
